var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("payment-gateway", {
        ref: "paymentGateway",
        attrs: {
          toolbar: false,
          paypal: false,
          compact: true
        },
        on: {
          card: _vm.listenCard,
          "card-switch": _vm.listenCardNew
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }